exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html{background-color:#f3f3f3;font-family:Roboto,Arial,sans-serif}.app-wrapper{margin-top:4rem}.left-bar{bottom:0;left:0;padding-top:3rem;position:fixed;top:0;width:295px}.main-content{margin-left:325px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/app.css
// module id = 1193
// module chunks = 0